@if (loading()) {
  <span class="job-readiness-indicator" title="Checking job readiness…">
    <i class="fa fa-spinner fa-spin text-muted"></i>
  </span>
} @else if (visual(); as v) {
  <button
    type="button"
    class="job-readiness-indicator k-button-link"
    kendoTooltip
    [title]="tooltip()"
    (click)="openDialog()"
  >
    <i class="fas {{ v.icon }} {{ v.colorClass }}"></i>
  </button>
}

@if (dialogOpen()) {
  <kendo-dialog
    [width]="560"
    (close)="closeDialog()"
    class="job-readiness-dialog"
  >
    <kendo-dialog-titlebar>
      @if (visual(); as v) {
        <i class="fas {{ v.icon }} {{ v.colorClass }} me-2"></i>
      }
      <span>Job Readiness</span>
    </kendo-dialog-titlebar>

    <p class="text-muted mb-3">
      Setup checks run at entry time so gaps surface here instead of at export.
      A red check will block export/batch-post until the job setup is fixed;
      keyed time itself stays editable until it exports.
    </p>

    <ul class="job-readiness-checks">
      @for (row of checkRows(); track row.check.CheckKey) {
        @let check = row.check;
        <li class="job-readiness-check">
          @if (row.visual; as cv) {
            <i class="fas {{ cv.icon }} {{ cv.colorClass }} check-icon"></i>
          }
          <div class="check-body">
            <div class="check-title">{{ row.label }}</div>
            <div class="check-message">{{ check.Message }}</div>
            @if (check.MissingItems?.length) {
              <div class="check-missing">
                @for (item of check.MissingItems; track item) {
                  <span class="missing-item">{{ item }}</span>
                }
              </div>
            }
          </div>
        </li>
      }
    </ul>

    <kendo-dialog-actions>
      <button kendoButton (click)="closeDialog()">Close</button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
